import { createAction, props } from "@ngrx/store";

import { Region } from "./region.model";

export const loadRegions = createAction("[Region] Load Regions");

export const loadRegionsSuccess = createAction(
  "[Region] Load Regions Success",
  props<{ regions: Region[] }>()
);

export const loadRegionsFailure = createAction(
  "[Region] Load Regions Failure",
  props<{ error: string }>()
);

export const toggleSelectedRegion = createAction(
  "[Region] Toggle Selected Region",
  props<{ region: string }>()
);

export const clearSelectedRegions = createAction(
  "[Region] Clear Selected Regions"
);

export const selectAllRegions = createAction("[Region] Select All Regions");

export const RegionActions = {
  loadRegions,
  loadRegionsSuccess,
  loadRegionsFailure,
  toggleSelectedRegion,
  clearSelectedRegions,
  selectAllRegions,
};
